import { Alert } from '@synoptic/ui-kit/alert/alert.js';
import { TrophyIcon } from '@synoptic/ui-kit/icons/react/trophy.js';
import { TournamentCta } from './tournament-cta';

export const NotSubmittedAlert = () => {
  return (
    <Alert
      color="prominent"
      icon={<TrophyIcon />}
      primaryAction={<TournamentCta size="small" />}
      elevated
    >
      You haven&apos;t submitted yet. Submit your post to join the Tournament!
    </Alert>
  );
};
